import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSubscriptionService } from 'redux/actions';
import get from 'lodash/get';
import { generateClientToken } from 'lib/auth';
import { formatAxiosRequestHeaders } from 'lib/helpers';

const useSubscriptionService = (serviceId) => {
  const dispatch = useDispatch();
  const { services } = useSelector((state) => state.subscriptions);
  const subscriptionService = get(services, serviceId, {});
  const { userId } = useSelector((state) => state.user);

  useEffect(() => {
    const getSubscriptionService = async () => {
      const token = generateClientToken(userId);
      const bearer = `Bearer ${token}`;
      const headers = formatAxiosRequestHeaders(undefined, bearer);
      await dispatch(fetchSubscriptionService(serviceId, headers));
    };
    getSubscriptionService();
  }, [serviceId, dispatch, userId]);

  return { ...subscriptionService };
};

export default useSubscriptionService;
